import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SharedService } from './shared.service';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from './base.service';
const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: 'root'
})
export class ForecastService extends BaseService{

  constructor(public http: HttpClient, public sharedService: SharedService) { 
    super(http, sharedService);
  }

  getDashboardData(endpoint: string): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('dashboard/'+endpoint)).pipe(
      map(res => {
        return res;
      })
    );
  }
  getForecastState(year: string, municipality: string): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('forecast/forecast-state/'+year+'/'+municipality)).pipe(
      map(res => {
        return res;
      })
    );
  }

  getForecastPerformanceState(year: string, month: string, municipality: string): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('forecast/forecast-state/'+year+'/'+month+'/'+municipality)).pipe(
      map(res => {
        return res;
      })
    );
  }

  
  submitForecast(forecast): Observable<any> {
    return this.http.post(this.sharedService.apiUrl("forecast/submit"), forecast, httpOptions).pipe(
      map((res) => {
        return res;
      })
    );
  }
  approveForecast(forecast): Observable<any> {
    return this.http.post(this.sharedService.apiUrl("forecast/approve"), forecast, httpOptions).pipe(
      map((res) => {
        return res;
      })
    );
  }
  reopenForecast(forecast): Observable<any> {
    return this.http.post(this.sharedService.apiUrl("forecast/reopen"), forecast, httpOptions).pipe(
      map((res) => {
        return res;
      })
    );
  }
}



